module.exports = __webpack_public_path__ + "static/step3-e5e690e3d667a1fdc24b20f0751b501b.png";